<template>
  <div class="product-card">
    <div class="numbers">{{ ind + 1 }}</div>
    
    <div class="product-left">
      <div class="product-image">
        <div class="honest-badge" :class="{ 'scanned': viewproduct.marking_code !== null }" v-if="viewproduct.marking && sklad1c !== '2-Готовая продукция'">
          <span class="honest-icon">
            <svg v-if="viewproduct.marking_code == null" width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
            </svg>
            <svg v-else width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="honest-text">Честный знак</span>
        </div>
        
        <img :src="`https://api.ultimatum.store/image/${viewproduct.dataproduct.images[0]}?quality=100&width=100&format=${getImageFormat(viewproduct.dataproduct.images[0])}`">
      </div>
      
      <div class="honest-scan" :class="{ 'scanned': viewproduct.marking_code !== null }" @click="scanHonest" v-if="viewproduct.marking && sklad1c !== '2-Готовая продукция'">
        <span class="scan-icon">
          <svg v-if="viewproduct.marking_code == null" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M3 8V6C3 4.89543 3.89543 4 5 4H8M3 16V18C3 19.1046 3.89543 20 5 20H8M21 8V6C21 4.89543 20.1046 4 19 4H16M21 16V18C21 19.1046 20.1046 20 19 20H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.5"/>
          </svg>
          <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="scan-text" @click="viewScaner = true">{{ viewproduct.marking_code == null ? 'Отсканировать' : 'Изменить' }}</span>
      </div>
    </div>
    
    <div class="product-right">
      <div class="product-title-block">
        <div class="product-title">{{viewproduct.name}}</div>
        <div class="product-sku">{{ viewproduct.artikul }}</div>
      </div>
      
      <div class="product-row">
        <select class="size-select" @change="updateSpecification" v-if="viewproduct.dataproduct.activityspecifications">
          <option value="0">не выбран</option>
          <option
            v-for="spec of viewproduct.dataproduct.specifications"
            :key="spec._id"
            :value="spec._id" 
            :selected="viewproduct.specification == spec._id"
            :disabled="viewDisable(spec)"
          >{{ spec.name }}</option>
        </select>
        <select class="size-select" v-else style="opacity:0.5"></select>
        
        <div class="blockandosk">
        <div class="quantity-selector">
          <button class="quantity-btn" @click="viewproduct.quantityChange('minus')">−</button>
          <span class="quantity-value">{{ viewproduct.quantity }}</span>
          <button class="quantity-btn" @click="viewproduct.quantityChange('add')">+</button>
        </div>
        <span>из {{viewOstatokReplace()}}</span>
        </div>

      </div>
    </div>
    
    <div class="product-prices">
      <div class="price-item">
        <span class="price-label">цена:</span>
        <span class="price-value current">{{viewproduct.price.toLocaleString('ru-RU')}} ₽</span>
        <span class="price-old" v-if="viewproduct.discount_procent !== 0">{{viewproduct.realprice.toLocaleString('ru-RU')}} ₽</span>
        <svg class="editprice" v-if="role == 'junior-manager'" @click="newprice = true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
          <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
       </svg>

      </div>
      
      <div class="product-actions">
        <button class="action-btn delete" @click="deleteProduct(ind,viewproduct.timeadd)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M18 6L6 18M6 6L18 18" stroke-linecap="round"/>
          </svg>
        </button>
        <button class="action-btn" @click="razdelProduct(ind)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <rect x="9" y="9" width="13" height="13" rx="2"/>
            <path d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>

  <transition name="slimetop">
    <div class="blockscanner" v-if="viewScaner">
      <p @click="viewScaner = false">Закрыть</p>
      <Suspense>
        <scanner :format="'data_matrix'" @barcode="getDataMatrix"/>
      </Suspense>
    </div>
  </transition>
  <transition name="opacity">
      <modalokno 
        :close="() => getZnak.view = false" 
        :text="`Маркировка`" 
        :button="'Закрыть'" 
        v-if="getZnak.view"
      >
        <div class="infoBlockGet">
        <div class="information">
          <span class="loader" v-if="getZnak.loading"></span>
          <p class="good" v-if="!getZnak.loading && getZnak.good">Честный знак одобрен</p>
          <p class="error" v-if="!getZnak.loading && !getZnak.good">Ошибка одобрения</p>
          <p>{{ getZnak.comment }}</p>
        </div>
      </div>
      </modalokno>
    </transition>

    <transition name="opacity">
      <modalokno 
        :close="() => newprice = false" 
        :text="`Стоимость`" 
        :button="'Закрыть'" 
        v-if="newprice"
      >
        <div class="infoBlockGet">
        <div class="information">
            <input type="number" v-model="viewproduct.newprice" />
        </div>
      </div>
      </modalokno>
    </transition>


</template>

<script setup>
import { deleteProduct, razdelProduct } from '@/controlles/basket/basket'
import { ref } from 'vue'
import axios from '@/utils/axios'
import { noloading,getImageFormat } from '@/controlles/general'
import scanner from '@/components/general/scanner.vue'
import { role, sklad1c } from '@/controlles/auth'


const props = defineProps(['p', 'in'])
const ind = props.in
const viewproduct = props.p
const newprice = ref(false)

const viewOstatokReplace = () => {
  try {
    if (viewproduct.activityspecifications) {
      const spec = viewproduct.dataproduct.specifications?.find(x => x._id == viewproduct.specification);
      if (spec && spec.balance) {
        const vieBl = spec.balance.find(x => x.name == sklad1c.value)?.count;
        if (vieBl !== undefined && vieBl !== null) return vieBl;
      }
    } else {
      if (viewproduct.dataproduct?.balance) {
        const vieBl = viewproduct.dataproduct.balance.find(x => x.name == sklad1c.value)?.count;
        if (vieBl !== undefined && vieBl !== null) return vieBl;
      }
    }
    return 0;
  } catch (error) {
    return 0;
  }
};

const getZnak = ref({
  view: false,
  comment: 'Проверяем данные честного знака',
  loading: true,
  good: false
})

const viewScaner = ref(false)

const viewDisable = (s) => {
  if (['club-owner','club-manager'].includes(role.value)) {
    const proverka = s.balance.find(x => x.name == sklad1c.value)
    return proverka ? proverka.count <= 0 : true
  }
  return false
}

const updateSpecification = (e) => { 
  viewproduct.specification = e.target.value 
}

const getDataMatrix = async (data) => {

  noloading.value = true
  getZnak.value.view = true
  getZnak.value.loading = true
  if(role.value !== 'junior-manager'){
    var getZnakData = await axios.post('https://api.ultimatum.store/arm/znak/check', { marking: data })
  }else{
    var getZnakData = await axios.post('https://api.ultimatum.store/arm/znak/shop/check', { marking: data })
  }
  if (getZnakData.status == 'good') {
    viewproduct.marking_uuid = getZnakData.uuid
    viewproduct.marking_code = window.btoa(unescape(encodeURIComponent(data)))
    viewproduct.marking_code_decode = data
    getZnak.value.good = true
    getZnak.value.loading = false
    getZnak.value.comment = ''
    viewScaner.value = false
  }
  
  if (getZnakData.status == 'error') {
    getZnak.value.good = false
    getZnak.value.loading = false
    getZnak.value.comment = getZnakData.comment
  }
  
  noloading.value = false
}
</script>

<style scoped>
.product-card {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  gap: 5px 10px;
  padding: 10px;
  background-color: var(--tile-bg);
  border: 1px solid var(--tile-border);
  margin-bottom: 20px;
  position: relative;
}

.numbers {
     position: absolute;
    z-index: 1;
    margin-left: 0px;
    font-size: 13px;
    font-weight: 400;
    margin-top: 10px;
    background-color: var(--btn-accent-bg);
    border-color: var(--btn-accent-bg);
    color: var(--btn-accent-text);
    width: 20px;
    height: 20px;
    display: grid;
    align-items: center;
    justify-items: center;
}

.product-left {
  display: grid;
  grid-template-rows: auto auto;
  gap: 8px;
  grid-column: 1;
}

.product-image {
  position: relative;
  width: 138px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-image img {
  width: 100%;
  height: auto;
}

.honest-badge {
    position: absolute;
    top: 0px;
    right: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    background-color: #dc3545;
    padding: 4px 8px;
    border-radius: 20px;
    z-index: 2;
    transition: all var(--transition-fast);

}

.honest-badge.scanned {
  background-color: rgba(34, 197, 94, 0.9);
}

.honest-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.honest-text {
  font-size: 9px;
  font-weight: 500;
  color: white;
  text-transform: uppercase;
}

.honest-scan {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  background-color: var(--bg-tertiary);
  border-radius: var(--border-radius-xl);
  cursor: pointer;
  width: 100%;
  border: 1px solid var(--border-light);
  justify-content: center;
}

.honest-scan:hover {
  background-color: var(--border-light);
}

.honest-scan.scanned {
  background-color: rgba(34, 197, 94, 0.1);
  border-color: rgba(34, 197, 94, 0.3);
}

.scan-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
}

.honest-scan.scanned .scan-icon,
.honest-scan.scanned .scan-text {
  color: #10b981;
}

.scan-text {
  font-size: 12px;
  font-weight: 500;
  color: var(--text-primary);
}

.product-right {
  display: grid;
  gap: 8px;
}

.product-title-block {
  display: grid;
  gap: 2px;
}

.product-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-sku {
  font-size: 11px;
  color: var(--text-tertiary);
}

.product-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  align-items: center;
}

.size-select {
  padding: 8px 24px 8px 12px;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-medium);
  border-radius: var(--border-radius-xl);
  font-size: 13px;
  color: var(--text-primary);
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236f6f6f' stroke-width='2'><polyline points='6 9 12 15 18 9'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
}

html.dark .size-select {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23a0a0a0' stroke-width='2'><polyline points='6 9 12 15 18 9'/></svg>");
}

.quantity-selector {
  display: grid;
  border: 1px solid var(--border-medium);
  border-radius: var(--border-radius-xl);
  overflow: hidden;
  background-color: var(--bg-primary);
  grid-template-columns: auto 1fr auto;
  align-items: center;
  justify-items: center;
}

.quantity-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-tertiary);
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: var(--text-primary);
}

.quantity-btn:hover {
  background-color: var(--border-medium);
}

.quantity-value {
  width: 32px;
  text-align: center;
  font-size: 14px;
  color: var(--text-primary);
}

.product-prices {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  align-items: center;
  grid-column: 1 / -1;
  padding-top: 8px;
  margin-top: 4px;
  border-top: 1px solid var(--border-light);
}

.price-item {
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}

.price-label {
  font-size: 11px;
  color: var(--text-tertiary);
  text-transform: uppercase;
}

.price-value.current {
  font-size: 15px;
  margin-left: 5px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.price-old {
  font-size: 12px;
  color: var(--text-tertiary);
  text-decoration: line-through;
  margin-left: 5px;
}

.product-actions {
  display: flex;
  gap: 4px;
  justify-self: end;
}

.action-btn {
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-full);
  background-color: var(--icon-btn-bg);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  padding: 0;
}

.action-btn:hover {
  background-color: var(--icon-btn-hover);
  color: var(--text-primary);
}

.action-btn.delete:hover {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.blockscanner {
  position: fixed;
  width: 100%;
  height: 100vh;
  display: grid;
  top: 0;
  left: 0;
  background: var(--black);
  z-index: 20;
}

.blockscanner p {
  color: var(--white);
  font-weight: 300;
  font-size: 16px;
  text-transform: uppercase;
  margin: 20px 0 0 20px;
}

.getZnak {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 40px);
  height: 100vh;
  background: var(--white);
  z-index: 999;
  padding: 20px;
  display: grid;
  align-items: center;
}

.loader {
  width: 25px;
  height: 25px;
  border: 2px solid var(--lightblue);
  border-bottom-color: var(--black);
  border-radius: 50%;
  display: inline-block;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.information {
  display: grid;
  gap: 10px;
  text-align: center;
  justify-items: center;
  margin-bottom: 40px;
}

.good { color: var(--green); }
.error { color: red; }

.blockandosk{
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 10px;
    align-items: center;
}
.blockandosk span{
    font-size: 13px;
    font-weight: 300;
}
.editprice{
    margin-left: 10px;
    transform: translateY(3px); 
}
</style>